export enum ChartType {
  View = 'view',
  Interval = 'interval',
  Line = 'line',
  Pie = 'pie',
}

export enum ChartCoordinateType {
  Theta = 'theta',
  Transpose = 'transpose',
}

export enum ChartLegendPosition {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}

export enum ChartLabelPosition {
  Inside = 'inside',
  Outside = 'outside',
  Spider = 'spider',
}
